import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Comments } from "../../Components/common/Comments/Comments";
import { VideoCard } from "../../Components/ui/VideoCard/VideoCard";
import { SearchFilterBar } from "../../Components/ui/SearchFilterBar/SearchFilterBar";
import { videoCards } from "../../data/empoweringDoctors";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import doctorAvatar from "../../assets/images/docter-profile.png";
import featuredThumb from "../../assets/images/cme-video.png";
import youtubeIcon from "../../assets/icons/youtube-icon.svg";
import "./cme.css";

const sampleComments = [
  {
    id: 1,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 2,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 3,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 4,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 5,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
  {
    id: 6,
    author: "Ralph Edwards",
    avatar: doctorAvatar,
    date: "Aug 19, 2021",
    text: "In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.",
    likes: 0,
    replies: [],
  },
];

export const Cme = () => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(false);

  const relatedVideos = videoCards.slice(0, 3);

  const fullDesc = `Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae. Integer feugiat, nulla eu blandit hendrerit, turpis elit pellentesque urna, in tincidunt purus sapien non lacus. Curabitur nec lacus sed nunc sollicitudin aliquet. Suspendisse potenti. Sed vulputate, nisi nec bibendum feugiat, ligula nulla facilisis nunc, ut sollicitudin...`;

  return (
    <div className="cme-page">
      {/* ── Hero Banner ── */}
      <section
        className="store-page__hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">Bizaario Store</p>
            <h1 className="store-page__hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      {/* ── Search + Filter ── */}
      <SearchFilterBar value={search} onChange={setSearch} />

      {/* ── Featured Video ── */}
      <section className="cme-featured">
        <Container className="p-0">
          <div className="cme-featured__player-wrap">
            <img
              src={featuredThumb}
              alt="Featured video"
              className="cme-featured__thumb"
            />
            <button className="cme-featured__play-btn" aria-label="Play video">
              <img src={youtubeIcon} alt="play" className="cme-featured__play-icon" />
            </button>
            <span className="cme-featured__duration">00:45:32</span>
            <div className="cme-featured__controls">
              <button className="cme-featured__ctrl-btn" aria-label="Rewind">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="1 4 1 10 7 10" />
                  <path d="M3.51 15a9 9 0 1 0 .49-4.95" />
                </svg>
              </button>
              <button
                className="cme-featured__ctrl-btn"
                aria-label="Play/Pause"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  stroke="none"
                >
                  <rect x="6" y="4" width="4" height="16" />
                  <rect x="14" y="4" width="4" height="16" />
                </svg>
              </button>
              <button className="cme-featured__ctrl-btn" aria-label="Forward">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10" />
                  <path d="M20.49 15a9 9 0 1 1-.49-4.95" />
                </svg>
              </button>
            </div>
          </div>

          {/* Video info */}
          <div className="cme-featured__info">
            <h2 className="cme-featured__title">
              Doctor Mike hosts the AMA Tribute to the Medical School Class of
              2023
            </h2>
            <div className="cme-featured__author-row">
              <img
                src={doctorAvatar}
                alt="Doctor Malik"
                className="cme-featured__author-avatar"
              />
              <div>
                <p className="cme-featured__author-name">By Doctor Malik</p>
                <p className="cme-featured__author-role">
                  Senior Cardiologist, Apollo Hospitals
                </p>
              </div>
            </div>
            <p className="cme-featured__desc">
              {expanded ? fullDesc.replace("...", "") : fullDesc}
              {!expanded && (
                <button
                  className="cme-featured__read-more"
                  onClick={() => setExpanded(true)}
                >
                  {" "}
                  Read More
                </button>
              )}
            </p>
          </div>
        </Container>
      </section>

      {/* ── Comments + You Also Like ── */}
      <section className="cme-bottom">
        <Container>
          <Row className="g-5">
            {/* Left — Comments */}
            <Col xs={12} lg={7}>
              <Comments comments={sampleComments} authorAvatar={doctorAvatar} />
            </Col>

            {/* Right — You Also Like */}
            <Col xs={12} lg={5}>
              <h3 className="cme-related__heading">You also Like</h3>
              <div className="cme-related__list">
                {relatedVideos.map((card) => (
                  <VideoCard key={card.id} {...card} />
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};
